import { ReactHOC } from '@shared/react';
import { StepsProvider } from './StepsProvider';
import { StepsComponentProps } from '../../interfaces';

export const withStepsProvider: ReactHOC<StepsComponentProps> = (Component) => {
    return (props) => {
        const {
            children,
            titles,
            headerClassName,
            footerClassName,
            submitLoading,
            onSubmit,
            className,
            submitLabel,
            footerVisible,
            onStepChange,
            previousLabel,
            nextLabel,
            stepsClickable,
        } = props;

        return (
            <StepsProvider
                titles={titles}
                _internalChildren={children}
                submitLoading={submitLoading}
                onSubmit={onSubmit}
                onStepChange={onStepChange}
                stepsClickable={stepsClickable}
            >
                <Component
                    {...props}
                    headerClassName={headerClassName}
                    footerClassName={footerClassName}
                    className={className}
                    submitLabel={submitLabel}
                    footerVisible={footerVisible}
                    previousLabel={previousLabel}
                    nextLabel={nextLabel}
                />
            </StepsProvider>
        );
    };
};
